import script from "./sw-item-editor-date.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-date.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-date.vue?vue&type=style&index=0&id=eb1eec74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb1eec74"]])

export default __exports__